class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length === 0;

    this.detailsContainer.setAttribute('open', true);

    if (this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('empty', true);
    }

    this.summaryToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  close() {
    this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('footer-accordion', FooterAccordion);
